<script>
	import { Radar,Charts } from 'vue-chartjs'


	export default {
        extends: Radar,

    data () {
        return {
            //
            chart_options: {
                scale: {
                    ticks: {
                        beginAtZero: true,
                        // min: parseInt(this.range.min),
                        // max: parseInt(this.range.max)
                    }
                },
                legend: {
                    position: 'bottom',
                },
                title: {
                    display: true,
                    text: this.title_text
                },
                responsive: true,
                maintainAspectRatio: false
            },
            datas: {}
        }

    },
        mounted () {
          //get a chart with a basic option

        },
        methods: {

            fetchDatas(datas) {

                this.renderChart(datas, this.chart_options);
            }

        },
	    props: {


            title_text:{
                type:String,
                required:false,
                default : ''
            },
            // range:{
            //     type:Object,
            //     required:false,
            //     default : {min : 0,max :100}
            // },
        }

	}
</script>
